// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2Q0ts","label":"LabeledBox_label__3YYuN"};